<template>
  <Container type="card-full">
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname="" :cols="cols"
        :showfooter="false" :showPage="true" :resizable="true"
        :needBlackRow="true" :needPopMenu="true" :canbeEdit="true"
        :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
        :editRules="editRules"
        :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  const SUCCESS = 1
  const valid = (cellValue, row, field,  msg,) => {
    return new Promise((resolve, reject)=> {
      request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename: 'btnrec',checkfield: field, checkval: cellValue, id: row.btnid, fieldid: 'btnid'}
        }).then (res => {
          res === SUCCESS ? reject(Error(msg)) : resolve()
      })
    })
  }
  export default {
    name: 'lcIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'btncode', fieldtype: 'C', title: '代号',calculExpr:'', editRender: { name: 'input'}},
          { field: 'btnname', fieldtype: 'C', title: '名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'btnicon', fieldtype: 'C', title: '按钮图标',calculExpr:'',editRender: { name: 'input'}},
          { field: 'btnid', fieldtype: 'C', visible: false}
        ],
        editRules: {
          'btncode': [{required: true, message: '输入内容不能为空'}],
          'btnname': [{required: true, message: '输入内容不能为空'}]
        },
        btn: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        btn:{}
      }
    },
    activated() {
      this.getPageList()
      if(this.btn.right!=''){
        this.isOperate = true
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delBtn())
      this.$on('CLOSE', () => this.close())
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delBtn () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/btn/delBtn',
            method: "post",
            data: this.btn
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.btn = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        if (!await this.$refs.xGrid.validError()) return 
        let data = await request({
          url: '/kfgl/btn/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getPageList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/btn/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
